module.exports = __webpack_public_path__ + "media/images/emblems/Thumb_uc_19885_w250_Wappen_Arbaz_VS_Blason_Arbaz_VS-fe780ebb2b6add24e607db5f421b26c2.png";